export default __webpack_public_path__ + "static/media/contact1.0e18cacf.svg";